<template>
  <form v-on:submit="submit" id="editPotentialeeStats" class="mt--4" novalidate>
    <h2 for="skills">Interviews</h2>

    <div class="form-row" v-for="interview of potentialeeStatsData.interviews" :key="interview.id">
      <div class="col-md-6 mb-3">
        <label for="interview">Employer</label>
        <input
          v-model="interview.employer"
          type="text"
          class="form-control"
          id="employer"
          placeholder="Employer"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-3 mb-3">
        <label for="interview">Position</label>
        <input
          v-model="interview.position"
          type="text"
          class="form-control"
          id="position"
          placeholder="Position"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-3 mb-3">
        <label for="interview">Date</label>
        <input
          v-model="interview.date"
          type="text"
          class="form-control"
          id="date"
          placeholder="Date"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <br />
      <div class="col-md-12 mb-3">
        <label for="interview">Notes</label>
        <textarea
          v-model="interview.notes"
          type="text"
          class="form-control"
          id="notes"
          placeholder="Notes"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
    </div>
    <div class="form-row" v-if="!readonly">
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-plus-circle" @click="addToInterviews"></i>
      </div>
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-minus-circle" @click="potentialeeStatsData.interviews.pop()"></i>
      </div>
    </div>

    <br/>
    <h2 for="skills">Applications</h2>

    <div class="form-row" v-for="apply of potentialeeStatsData.applications" :key="apply.id">
      <div class="col-md-6 mb-3">
        <label for="apply">Employer</label>
        <input
          v-model="apply.employer"
          type="text"
          class="form-control"
          id="employer"
          placeholder="Employer"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-3 mb-3">
        <label for="position">Position</label>
        <input
          v-model="apply.position"
          type="text"
          class="form-control"
          id="position"
          placeholder="Position"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-3 mb-3">
        <label for="date">Date</label>
        <input
          v-model="apply.date"
          type="text"
          class="form-control"
          id="date"
          placeholder="Date"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <br />
      <div class="col-md-12 mb-3">
        <label for="interview">Notes</label>
        <textarea
          v-model="apply.notes"
          type="text"
          class="form-control"
          id="notes"
          placeholder="Notes"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
    </div>
    <div class="form-row" v-if="!readonly">
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-plus-circle" @click="addToApplications"></i>
      </div>
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-minus-circle" @click="potentialeeStatsData.applications.pop()"></i>
      </div>
    </div>

    <br/>
    <h2 for="skills">Hired</h2>

    <div class="form-row" v-for="hire of potentialeeStatsData.hired" :key="hire.id">
      <div class="col-md-6 mb-3">
        <label for="hire">Employer</label>
        <input
          v-model="hire.employer"
          type="text"
          class="form-control"
          id="employer"
          placeholder="Employer"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-3 mb-3">
        <label for="hire">Position</label>
        <input
          v-model="hire.position"
          type="text"
          class="form-control"
          id="position"
          placeholder="Position"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-3 mb-3">
        <label for="hire">Date</label>
        <input
          v-model="hire.date"
          type="text"
          class="form-control"
          id="date"
          placeholder="Date"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <br />
      <div class="col-md-12 mb-3">
        <label for="hire">Notes</label>
        <textarea
          v-model="hire.notes"
          type="text"
          class="form-control"
          id="notes"
          placeholder="Notes"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
    </div>
    <div class="form-row" v-if="!readonly">
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-plus-circle" @click="addToHired"></i>
      </div>
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-minus-circle" @click="potentialeeStatsData.hired.pop()"></i>
      </div>
    </div>

    <br/>
    <h2 for="skills">Contacted</h2>

    <div class="form-row" v-for="contact of potentialeeStatsData.contacted" :key="contact.id">
      <div class="col-md-9 mb-3">
        <label for="contact">Employer</label>
        <input
          v-model="contact.employer"
          type="text"
          class="form-control"
          id="employer"
          placeholder="Employer"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-3 mb-3">
        <label for="contact">Date</label>
        <input
          v-model="contact.date"
          type="text"
          class="form-control"
          id="date"
          placeholder="Date"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <br />
      <div class="col-md-12 mb-3">
        <label for="contact">Notes</label>
        <textarea
          v-model="contact.notes"
          type="text"
          class="form-control"
          id="notes"
          placeholder="Notes"
          required
          :readonly="readonly"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
    </div>
    <div class="form-row" v-if="!readonly">
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-plus-circle" @click="addToContacted"></i>
      </div>
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-minus-circle" @click="potentialeeStatsData.contacted.pop()"></i>
      </div>
    </div>

    <br />
    <button class="btn btn-primary" type="submit" v-if="!readonly">Save</button>
  </form>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

export default {
  name: "potentialeestastform",
  components: {},
  props: {
    potentialee: null,
    readonly: Boolean
  },
  data() {
    return {
      potentialeeStatsData: {
        views: 0,
        interviews: [],
        applications: [],
        contacted: [],
        hired: []
      }
    };
  },
  mounted() {},
  computed: {},
  watch: {
    potentialee(newPotentialee, _) {
      const pData = newPotentialee;

      if (pData.stats === undefined) {
        pData.stats = {};
      }

      const potentialeeStatsData = {
        views: pData.stats.views ?? null,
        interviews: pData.stats.interviews ?? [],
        applications: pData.stats.applications ?? [],
        contacted: pData.stats.contacted ?? [],
        hired: pData.stats.hired ?? []
      };

      this.potentialeeStatsData = potentialeeStatsData;
    }
  },
  methods: {
    addToContacted() {
      this.potentialeeStatsData.contacted.push({});
    },
    addToHired() {
      this.potentialeeStatsData.hired.push({});
    },
    addToInterviews() {
      this.potentialeeStatsData.interviews.push({});
    },
    addToApplications() {
      this.potentialeeStatsData.applications.push({});
    },
    refreshCurrentPotentialeesData() {
      this.$parent.$parent.currentPageRefresh();
    },
    submit: function(event) {
      const form = document.getElementById("editPotentialeeStats");

      event.preventDefault();
      event.stopPropagation();

      form.classList.add("was-validated");

      if (form.checkValidity()) {
        const pData = this.potentialeeStatsData;
        const curOrgId = this.$store.state.usermain.curOrg.id;

        const potentialeeId = this.potentialee.id;

        const finalPotentialeeStatsData = {
          views: pData.views,
          interviews: pData.interviews,
          applications: pData.applications,
          contacted: pData.contacted,
          hired: pData.hired
        };

        console.log(finalPotentialeeStatsData);

        firebase
          .firestore()
          .doc(`organizations/${curOrgId}/potentialees/${potentialeeId}`)
          .update({ stats: finalPotentialeeStatsData })
          .then(() => {
            $("#viewPotentialeeStats").modal("hide");

            this.refreshCurrentPotentialeesData();
          })
          .catch(function(error) {
            console.error(error);
          });
      }
    }
  }
};
</script>

<style scoped>
</style>
